<template>
  <div class="unilorin-top">
    <div class="logo">
      <img alt="UNILORIN Logo" src="../assets/unilorin-icon.png" width="60" />
    </div>
    <div class="name">
      <div class="university-name">University of Ilorin</div>
      <div class="platform-name">Support Ticketing Platform</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UNILORINTop'
}
</script>

<style>
.unilorin-top {
  width: 100vw;
  height: auto;
  background-color: #000d4e;
  display: flex;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  align-items: center;
}

.unilorin-top .logo {
  margin-left: 2rem;
  /*  img {
      width: 5rem;
    } */
}

.unilorin-top .name {
  margin-left: 1rem;
  color: #f9f9f9;
}

.unilorin-top .name .university-name {
  font-weight: bold;
  font-size: 1.3rem;
}
.unilorin-top .name .platform-name {
  font-size: 1.1rem;
}

@media (max-width: 576px) {
  .unilorin-top .logo {
    margin-left: 0.7rem;
  }
  .unilorin-top .logo img {
    width: 3rem;
    height: auto;
  }

  .unilorin-top .name {
    margin-left: 0.7rem;
  }
  .unilorin-top .name .university-name {
    font-size: 0.9rem;
  }
  .unilorin-top .name .platform-name {
    font-size: 0.7rem;
  }
}
</style>
